import { render, staticRenderFns } from "./drawList.vue?vue&type=template&id=5f137111&scoped=true&"
import script from "./drawList.vue?vue&type=script&lang=js&"
export * from "./drawList.vue?vue&type=script&lang=js&"
import style0 from "./drawList.vue?vue&type=style&index=0&id=5f137111&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f137111",
  null
  
)

export default component.exports